import { render } from "./BaixaContasReceberIndex.vue?vue&type=template&id=ecfd6242&scoped=true&ts=true"
import script from "./BaixaContasReceberIndex.vue?vue&type=script&lang=ts"
export * from "./BaixaContasReceberIndex.vue?vue&type=script&lang=ts"

import "./BaixaContasReceberIndex.vue?vue&type=style&index=0&id=ecfd6242&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecfd6242"]])

export default __exports__